import { render, staticRenderFns } from "./NavMobileLink.vue?vue&type=template&id=5835faa0&scoped=true"
import script from "./NavMobileLink.vue?vue&type=script&lang=js"
export * from "./NavMobileLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5835faa0",
  null
  
)

export default component.exports